import { Injectable } from "@angular/core";
import { ArticleListItem } from "../models/article/article-list-item";

@Injectable({providedIn: 'root'})
export class ArticleListAdapter {

  adapt(item: any, parentId:string = '', addChildren:boolean = true): ArticleListItem {
    return {
      id: item.id,
      name: item.title,
      articleNumber: item.number ??'',
      children: addChildren?(item.children??[]).map((x:any) => this.adapt(x,item.id)):[],
      language: item.language.replace('/languages/', ''),
      parentId: parentId ? parentId : '',
      updatedAt : item.updatedAt,
      nestingNumber:item.nestingNumber??'',
      isFolder:(item.children??[]).length > 0,
      slug:item.slug??''
    };
  }

  adaptFromManualArticle(item: any, parentId: string = '', addChildren:boolean = true): ArticleListItem {
    return {
      id: item.id,
      name: item.title,
      articleNumber: item.number ??'',
      children: addChildren?(item.children??[]).map((x:any) => this.adaptFromManualArticle(x,item.id)):[],
      language: item.article.language.replace('/languages/', ''),
      parentId: parentId ? parentId : '',
      updatedAt : item.article.updatedAt,
      nestingNumber:item.nestingNumber??'',
      isFolder:(item.children??[]).length > 0,
      slug:item.article.slug??''
    };
  }
}
